<template>
	<div class="app-container">
		<div class="row">
			<div class="col-12">
				<swiper :options="swiperOptionTop" class="gallery-top" ref="swiperTop">
					<swiper-slide class="slide-1">
						<router-link :to="{name: 'Register', params: {id: 7}}">
							5OOTL %100 Hoş geldin bonusu
					</router-link></swiper-slide>
					<swiper-slide class="slide-2">
						<router-link :to="{name: 'Register', params: {id: 7}}">
						Hemen kayıt ol 20‎₺ deneme bonusunu al
					</router-link></swiper-slide>
				</swiper>
			</div>
		</div>
		<div class="row px-4 mt-2">
			<div class="col-sm-6">

			</div>
			<div class="col-sm-6">

			</div>
		</div>
	</div>
</template>

<script>

    export default {
        name: 'welcomeBonusBanner',
        data() {
            return {
                swiperOptionTop: {
                    spaceBetween: 10,
                    autoplay: true,
                    loop: true,
                    loopedSlides: 2,
                }
            }
        },
        mounted() {
            this.$nextTick(() => {
                const swiperTop = this.$refs.swiperTop.swiper
                const swiperThumbs = this.$refs.swiperThumbs.swiper
                swiperTop.controller.control = swiperThumbs
            swiperThumbs.controller.control = swiperTop
        })
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

	.swiper-container {
		font-size: 30px;
		text-transform: uppercase
	}
	.swiper-slide {
		height: 40px;
	}
	.swiper-slide a{
		width: 100%;
		height: 100%;
		float: left;
		color: yellow;
	}
	.gallery-top {
		height: 100%;
		width: 100%;
	}

</style>



// WEBPACK FOOTER //
// src/components/ui/asset/welcomeBonusBanner.vue